import {
    ReactElement,
} from 'react';

import {Stack,} from '@mantine/core';

import {usePhases} from '../hooks/usePhases.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {usePhasesSelection} from '../hooks/usePhasesSelection.ts';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {usePhasesPaging} from "../hooks/usePhasesPaging.ts";
import {usePhasesSearch} from "../hooks/usePhasesSearch.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";
import {useParams} from "react-router-dom";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    // Scope list to the enclosing playbook when rendered inside /playbooks/:id.
    const {id: playbookId} = useParams();
    const filters: Record<string, string> = playbookId ? {playbookId} : {};

    const {
        columns,
        visibleItems: records,
        loading,
    } = usePhases(filters);

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = usePhasesPaging();

    const {
        handleFilterByKeyword,
    } = usePhasesSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = usePhasesSelection();


    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeletePhase)) {
        selectedRecords = Object.keys(selection)
                                .filter(id => selection[id] === true)
                                .map(id => ({ id }))
    }

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        handleRowSelection((item as any).id, true)
                    })
                }}
                fetching={loading}
            />


        </Stack>
    );


};
